import { setCompanies } from "../../reducers/dashboardSlice";
import { LocalStorageUtil } from "../../utils/LocalStorageUtil";
import * as actionTypes from "../actions/actions";
import { store } from "../store";

export const getAllOrgNames = (action: any) => async (dispatch: any) => {
  const orgName = store.getState().getCompanyNames.companyNames;
  const reload = action.reload ? action.reload : false;
  let url = "";
  if (
    +LocalStorageUtil.getItem("saasOrgId") === 1 ||
    +LocalStorageUtil.getItem("loggedInSaasOrgId") === 1
  ) {
    url = `/api/reservation/filter/companyNames?saasOrgId=${LocalStorageUtil.getItem(
      "saasOrgId"
    )}`;
  } else {
    url = `/api/organization/getOrgByUser?userId=${LocalStorageUtil.getItem(
      "userId"
    )}`;
  }
  try {
    if (orgName?.length && !reload) {
      action.callback(orgName);
    } else {
      dispatch({
        type: actionTypes.LOAD_COMPANYNAMES_REQUEST,
      });
      const resp = await action.api.get(`${url}`);
      if (resp.data) {
        const respData = resp.data.map((item: any) => {
          return {
            orgName: item.orgName,
            orgId: item.orgId,
            saasOrgId: item.orgId,
          };
        });
        const arr: any = [{ orgName: "All", orgId: "All" }, ...resp.data];
        dispatch({
          type: actionTypes.LOAD_COMPANYNAMES_SUCCESS,
          payload: arr,
        });
        action.callback(arr);
      }
    }
  } catch (error) {
    dispatch({
      type: actionTypes.LOAD_COMPANYNAMES_FAILURE,
    });
    console.log(error, "ERR");
  }
};

export const getAllOrgDetails = (action: any) => async (dispatch: any) => {
  const allOrgName = store.getState().getCompanyNames.allOrganizations;
  const reload = store?.getState()?.getCompanyNames?.isReload;
  try {
    if (LocalStorageUtil.getItem("root") === "true") {
      if (allOrgName?.length && !reload) {
        action.callback(allOrgName);
      } else {
        dispatch({
          type: actionTypes.LOAD_COMPANYNAMES_REQUEST,
        });
        let url = "";
        const orgId = +LocalStorageUtil.getItem("saasOrgId");
        if (
          orgId == 1 ||
          action?.isAllOrgs ||
          +LocalStorageUtil.getItem("loggedInSaasOrgId") === 1
        ) {
          url = `/api/organization/getAllOrganization`;
        } else {
          url = `/api/organization/getOrgByUser?userId=${LocalStorageUtil.getItem(
            "userId"
          )}`;
        }
        let resp = await action.api.get(url);
        let orgs: any = [];
        if (resp.data) {
          if (resp.data?.organizationApiList?.content) {
            orgs = resp.data?.organizationApiList?.content
              ?.filter(
                (org: any) =>
                  action.ignoreFilter ||
                  (org.isOrgApproved === "Approved" &&
                    org.orgStatus === "Active")
              )
              .map((item: any) => {
                return {
                  orgId: item.orgId,
                  orgName: item.orgName,
                  saasOrgId: item.saasOrgId || item.orgId,
                  orgStatus: item.orgStatus,
                  usageType: item.usageType || item.orgType,
                  isOrgApproved: item.isOrgApproved,
                  isReferred: item.isReferred,
                };
              });
          } else {
            orgs = resp.data?.map((item: any) => {
              return {
                orgId: item.orgId,
                orgName: item.orgName,
                saasOrgId: item.saasOrgId || item.orgId,
                orgStatus: item.orgStatus,
                usageType: item.usageType || item.orgType,
                isOrgApproved: item.isOrgApproved,
                isReferred: item.isReferred,
              };
            });
          }

          dispatch({
            type: actionTypes.LOAD_ORGANIZATIONS_SUCCESS,
            payload: orgs,
          });
          action.callback(orgs);
        }
      }
    } else {
      try {
        let orgs: any = [];
        let url = "";
        const orgId = LocalStorageUtil.getItem("saasOrgId");
        if (
          orgId == 1 ||
          action?.isAllOrgs ||
          +LocalStorageUtil.getItem("loggedInSaasOrgId") === 1
        ) {
          url = `/api/organization/getAllOrganization`;
        } else {
          url = `/api/organization/getOrgByUser?userId=${LocalStorageUtil.getItem(
            "userId"
          )}`;
        }
        let resp = await action.api.get(url);
        if (resp.data) {
          if (resp.data?.organizationApiList?.content) {
            orgs = resp.data?.organizationApiList?.content
              ?.filter(
                (org: any) =>
                  action.ignoreFilter ||
                  (org.isOrgApproved === "Approved" &&
                    org.orgStatus === "Active")
              )
              .map((item: any) => {
                return {
                  orgId: item.orgId,
                  orgName: item.orgName,
                  saasOrgId: item.saasOrgId || item.orgId,
                  orgStatus: item.orgStatus,
                  usageType: item.usageType || item.orgType,
                  isOrgApproved: item.isOrgApproved,
                  isReferred: item.isReferred,
                };
              });
          } else {
            orgs = resp.data?.map((item: any) => {
              return {
                orgId: item.orgId,
                orgName: item.orgName,
                saasOrgId: item.saasOrgId || item.orgId,
                orgStatus: item.orgStatus,
                usageType: item.usageType || item.orgType,
                isOrgApproved: item.isOrgApproved,
                isReferred: item.isReferred,
              };
            });
          }

          dispatch(setCompanies(orgs));
          action.callback(orgs);
        }
      } catch (err) {
        console.log(err);
      }
    }
  } catch (error) {
    dispatch({
      type: actionTypes.LOAD_COMPANYNAMES_FAILURE,
    });
    console.log(error, "ERR");
  }
};
